import { ApolloClient } from '@apollo/client'
import { RESET_SECURE_VAULT_USER } from './graphql/mutations'

export type ResetUserVault = {
  resetSecureVaultUser: boolean
}

export const resetUserVaults = async (
  projectClient: ApolloClient<unknown>,
  internalId: string,
): Promise<void> => {
  const { data } = await projectClient.mutate<ResetUserVault>({
    mutation: RESET_SECURE_VAULT_USER,
    variables: { sub: internalId },
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  })

  if (!data?.resetSecureVaultUser) {
    throw new Error(
      'There was an error resetting vaults for this user. Please check that the user ID is correct and try again.',
    )
  }
}
